/* eslint-disable */
import styles from './index.module.scss'
import { Link } from 'react-router-dom'
import { PageContext } from '../../../../context/PageContextProvider'
import { useContext } from 'react'

const ServiceCard = ({ click, name, link, active, detail = true }) => {
  const { language } = useContext(PageContext)
  const details = {
    AZ: 'Detallı baxın',
    ENG: 'See details',
    RU: 'Смотрите подробности',
    TR: 'Detaylı inceleyin',
  }
  const follow = {
    AZ: 'Keçid et',
    ENG: 'Follow the link',
    RU: 'Перейти по ссылке',
    TR: 'Geçiş yap',
  }
  const handleClick = (e) => {
    if (click) {
      click(e)
    } else if (link) {
      window.location.href = link
    }
  }
  return (
    <div
      onClick={handleClick}
      className={`${styles.card} ${active ? styles.active : null} bpg-card-neon`}
      style={{ cursor: 'pointer' }}
    >
      <h3>{name}</h3>
      <Link to={link || '#'}>{detail ? (details[language] || details.AZ) : (follow[language] || follow.AZ)}</Link>
    </div>
  )
}

export default ServiceCard
